import { Dialog } from "@progress/kendo-react-dialogs";
import { updateAction } from "../../../../API/Display/Display";
import ActionForm from "../ActionForm/ActionForm";
import { useSelectedPage } from "../../../../Hooks/Display/usePages";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useActions } from "../../../../Hooks/Display/useComponentProperties";
import { getActionById } from "../utils";

function UpdateActionDialog() {

    const [actionsState, dispatch] = useActions();

    const selectedAction = getActionById(actionsState.actions, actionsState.updateActionId);
    
    async function createNewAction(event, action) {
        dispatch.updateAction(selectedAction.id, action);
        dispatch.toggleUpdateActionDialog();
    }

    return (
        <Dialog
            title="Update Action"
            width={450}
            onClose={dispatch.toggleUpdateActionDialog}
        >
            <ActionForm
                initialValue={selectedAction}
                submitButtonText={"Update"}
                onSubmit={createNewAction}
                onCancel={dispatch.toggleUpdateActionDialog} />
        </Dialog>
    )
}

export default UpdateActionDialog;